import React, { useState } from "react";
import { supabase } from "./supabaseClient";

export default function LoginPage() {
  const [mode, setMode] = useState("password"); // 'password' | 'email' | 'phone'

  // shared
  const [note, setNote] = useState("");

  // email+password
  const [epEmail, setEpEmail] = useState("");
  const [epPwd, setEpPwd] = useState("");
  const [isSignUp, setIsSignUp] = useState(false);

  // email magic
  const [email, setEmail] = useState("");

  // phone otp
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [smsSent, setSmsSent] = useState(false);

  const onEPSubmit = async (e) => {
    e.preventDefault(); setNote("");
    try {
      if (isSignUp) {
        const { error } = await supabase.auth.signUp({ email: epEmail, password: epPwd });
        if (error) throw error;
        setNote("Account created. Check your email to verify (if required). You can now sign in.");
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email: epEmail, password: epPwd });
        if (error) throw error;
        window.location.replace("/");
      }
    } catch (err) { setNote(err.message); }
  };

  const sendEmailLink = async (e) => {
    e.preventDefault(); setNote("");
    try {
      const redirectTo = `${window.location.origin}/`;
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: { emailRedirectTo: redirectTo, shouldCreateUser: true },
      });
      if (error) throw error;
      setNote("Check your inbox for a login link.");
    } catch (err) { setNote(err.message); }
  };

  const sendSMS = async (e) => {
    e.preventDefault(); setNote("");
    try {
      const { error } = await supabase.auth.signInWithOtp({
        phone,
        options: { shouldCreateUser: true },
      });
      if (error) throw error;
      setSmsSent(true);
    } catch (err) { setNote(err.message); }
  };

  const verifySMS = async (e) => {
    e.preventDefault(); setNote("");
    try {
      const { error } = await supabase.auth.verifyOtp({ type: "sms", phone, token: otp });
      if (error) throw error;
      window.location.replace("/");
    } catch (err) { setNote(err.message); }
  };

  return (
    <div className="page">
      <div className="card login">
        <h2 className="login-title">
          {mode === "password" && "Welcome back"}
          {mode === "email" && "What’s your email?"}
          {mode === "phone" && "What’s your phone number?"}
        </h2>
        <p className="login-sub">
          {mode === "password" && "Sign in with your email and password."}
          {mode === "email" && "We’ll email you a magic link to sign in securely."}
          {mode === "phone" && "We’ll text you a code to verify your account."}
        </p>

        {mode === "password" && (
          <form onSubmit={onEPSubmit} className="login-form">
            <label className="field-label">Email</label>
            <input className="field-input" type="email" value={epEmail} onChange={e=>setEpEmail(e.target.value)} required />
            <label className="field-label">Password</label>
            <input className="field-input" type="password" value={epPwd} onChange={e=>setEpPwd(e.target.value)} required />

            <div className="muted">
              Prefer a link?{" "}
              <button type="button" className="linklike" onClick={()=>setMode("email")}>Log in with email link</button>
              {/* {"  "}•{"  "} */}
              {/* <button type="button" className="linklike" onClick={()=>setMode("phone")}>Use phone</button> */}
            </div>

            <button className="primary">{isSignUp ? "Create account" : "Sign in"}</button>
            <div className="muted" style={{marginTop:8}}>
              {isSignUp ? "Already have an account?" : "New here?"}{" "}
              <button type="button" className="linklike" onClick={()=>setIsSignUp(v=>!v)}>
                {isSignUp ? "Sign in" : "Create one"}
              </button>
            </div>
            {!!note && <p className="feedback">{note}</p>}
          </form>
        )}

        {mode === "email" && (
          <form onSubmit={sendEmailLink} className="login-form">
            <label className="field-label">Email</label>
            <input className="field-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} required />
            <div className="muted">
              Prefer password?{" "}
              <button type="button" className="linklike" onClick={()=>setMode("password")}>Use email & password</button>
              {/* {"  "}•{"  "}
              <button type="button" className="linklike" onClick={()=>setMode("phone")}>Use phone</button> */}
            </div>
            <button className="primary">Send link</button>
            {!!note && <p className="feedback">{note}</p>}
          </form>
        )}

        {mode === "phone" && (
          <form onSubmit={smsSent ? verifySMS : sendSMS} className="login-form">
            <label className="field-label">Phone number</label>
            <input className="field-input" type="tel" value={phone} onChange={e=>setPhone(e.target.value)} placeholder="(xxx) xxx-xxxx" required />
            <div className="muted">
              Having trouble?{" "}
              <button type="button" className="linklike" onClick={()=>setMode("email")}>Log in with email</button>
            </div>
            {smsSent && (
              <>
                <label className="field-label">Enter 6-digit code</label>
                <input className="field-input" inputMode="numeric" value={otp} onChange={e=>setOtp(e.target.value)} placeholder="••••••" required />
              </>
            )}
            <button className="primary">{smsSent ? "Verify code" : "Send code"}</button>
            {!!note && <p className="feedback">{note}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
